import { publish } from 'services/CentrifugoWS';

import {
  completePurchaseCentrifugoMessage,
  finishedSaleCentrifugoMessage,
  customerCreationAcceptedCentrifugoMessage,
} from '../constants';
import DuplicateCustomersSelectionForm from '../DuplicateCustomersSelectionForm';
import { sendUpsellProductsToDisplay } from '../features/upsellProducts';
import { DisplayIntegration } from '../types';

import FlutterHeader from './components/ComponentHeader';

import { getAfterSaleAction, getChannelName, getQRCodeConfig } from '..';

export const FlutterDisplay: DisplayIntegration = {
  afterSaveSalesDocument: (p, ep) => async (dispatch, getState) => {
    const afterSaleAction = getAfterSaleAction(getState());
    const channelName = getChannelName(getState());
    const QRCodeConfig = getQRCodeConfig(getState());
    if (afterSaleAction === 'email') {
      publish({
        channel: `customer_display:${channelName}`,
        message: completePurchaseCentrifugoMessage,
      });
    } else if (afterSaleAction === 'customQR') {
      publish({
        channel: `customer_display:${channelName}`,
        message: {
          action: 'SHOW_QR',
          qrCodeData: QRCodeConfig.qrCodeData,
          qrTitle: QRCodeConfig.qrTitle,
          qrSubtitle: QRCodeConfig.qrSubtitle,
          isAfterSaleQR: true,
        },
      });
    } else if (afterSaleAction === 'receiptQR') {
      publish({
        channel: `customer_display:${channelName}`,
        message: {
          action: 'SHOW_QR',
          qrCodeData: ep.salesDocument.receiptLink,
          qrTitle: QRCodeConfig.qrTitle,
          qrSubtitle: QRCodeConfig.qrSubtitle,
          isAfterSaleQR: true,
        },
      });
    } else {
      publish({
        channel: `customer_display:${channelName}`,
        message: finishedSaleCentrifugoMessage,
      });
    }
  },
  afterSaveCustomer: () => async (dispatch, getState) => {
    const channelName = getChannelName(getState());
    publish({
      channel: `customer_display:${channelName}`,
      message: customerCreationAcceptedCentrifugoMessage,
    });
  },
  beforeSoftLogout: () => async (_dispatch, getState) => {
    const channelName = getChannelName(getState());
    const channel = `customer_display:${channelName}`;
    publish({
      channel,
      message: finishedSaleCentrifugoMessage,
    });
  },
  beforeHardLogout: () => async (_dispatch, getState) => {
    const channelName = getChannelName(getState());
    const channel = `customer_display:${channelName}`;
    publish({
      channel,
      message: finishedSaleCentrifugoMessage,
    });
  },
  components: {
    DuplicateCustomersSelectionForm,
  },
  onAddProduct: sendUpsellProductsToDisplay,
  ComponentHeader: FlutterHeader,
};
